<template>
  <v-flex xs12>
      <p class="title mx-0 pb-0 mb-0 px-2">{{ title }}</p>
    <v-layout wrap>
      <v-flex xs12 md6 v-for="creator in creators" :key="creator.id">
        <creator-tile :creator="creator" :creators="creators" :type="type" />
      </v-flex>
      <v-flex xs12 md6>
        <creator-add-tile :chosenCreators="creators" :type="type"/>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { getContentCreators } from "@/firebase/api/creator";
import CreatorTile from "@/components/creator/Tile";
import CreatorAddTile from "@/components/creator/AddTile";
import CreatorMixin from "@/mixins/creatorData.js"

export default {
  components: { CreatorTile, CreatorAddTile },
  mixins: [CreatorMixin],
  props: {
    content: Object,
  },
  data: () => ({
    creators: [],
  }),
  mounted() {
    this.$bind("creators", getContentCreators(this.$route.params.contentID, this.type));
  },
  computed: {

    title() {
      let title = this.typeStr + 'es'
      title = title.charAt(0).toUpperCase() + title.substr(1).toLowerCase();
      return title
    },
    sortedCreators() {
      let creatorsCopy = this.creators.slice();
      creatorsCopy.sort((a, b) => a.name.localeCompare(b.name));
      return creatorsCopy;
    }
  },
};
</script>